import { Component, Input, input, InputSignal, output } from '@angular/core';
import {
  ContractorAppEntityContractorWrite
} from '../../../../../../../openapi';
import { AccordionGroupComponent } from '../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../common/accordion-item/accordion-item.component';
import { EntityLabelPipe } from '../../../../../../../pipes/applicant-label.pipe';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';

@Component({
  selector: 'app-contractors-preview',
  standalone: true,
  imports: [
    AccordionGroupComponent,
    AccordionItemComponent,
    EntityLabelPipe,
    CommonModule,
    LabelComponent,
    AlertComponent
  ],
  templateUrl: './contractors-preview.component.html'
})
export class ContractorsPreviewComponent {

  @Input()
  public noDataInfo: string | null = null;

  @Input()
  public expanded: boolean = true;

  public showActions = input(false);

  public canEdit = input(true);

  public contractors: InputSignal<Array<ContractorAppEntityContractorWrite>> = input<Array<ContractorAppEntityContractorWrite>>([]);

  public onRemove = output<number>();

  public onEdit = output<{ v: ContractorAppEntityContractorWrite, i: number }>();

  public remove(event: Event, index: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.onRemove.emit(index);
  }

  public edit(event: Event, i: number, v: ContractorAppEntityContractorWrite): void {
    event.preventDefault();
    event.stopPropagation();
    this.onEdit.emit({ i, v });
  }
}
